
import 'element-ui/lib/theme-chalk/time-picker.css';
import 'element-ui/lib/theme-chalk/icon.css';

import { Component , Vue , Watch} from "vue-property-decorator";
@Component
export default class orderList extends Vue {
    params:any={
        listingid:'',
        seller_onlyid:'',
        order_status:0,
        page_num:1,
        page_size:20,
        times: '',
        pageTotal:0
    }
    orderData:any = []
    loading:boolean = false
    isSelect:boolean = false//是否批量选择订单
    allSelect:boolean = false//是否全选
    selectOrder:any = []//选择的订单
    isOrderManage:boolean = true // 弹窗boolean
	api:any={
		getOrderListData:"https://opc" + this.domain + "/ule-live-amdin/api/v1/room/liveOrderMgr/list",//获取订单列表接口
		cancelOrder:"https://opc" + this.domain + "/ule-live-amdin/api/v1/room/liveOrderMgr/cancel",//取消订单
		cancelAllOrder:"https://opc" + this.domain + "/ule-live-amdin/api/v1/room/liveOrderMgr/batchCancel"//批量取消订单
	}
    @Watch('isOrderManage') 
	onChange(val:any,oldVal:any){
        if(!val){
            this.$emit('hintChange' , {name:'isOrderManage',val:val})
        }
	}
	mounted() {
		this.getOrderListData()
	}
    search(){
        this.params.page_num = 1
        this.getOrderListData()
    }
    orderOperation(){
        this.isSelect = !this.isSelect
    }
    orderSelect(order:any){//订单选择
        order.select = !order.select
        this.getSelectOrder(false,false)
    }
    allselectOrder(){//全选订单
        this.allSelect = !this.allSelect
        this.getSelectOrder(true,this.allSelect)
    }
    getSelectOrder(all:boolean,isSelect:boolean){
        this.selectOrder = []
        this.allSelect = true
        this.orderData.forEach((order:any) => {
            if (order.orderStatusName == '待付款') {
                if (all) {
                    if (isSelect) {
                        this.selectOrder.push(order.escOrderid)
                        order.select = true
                    }else{
                        order.select = false
                        this.allSelect = false
                    }
                }else{
                    if (order.select) {
                        this.selectOrder.push(order.escOrderid)
                    }else{
                        this.allSelect = false
                    }
                }
            }
        });
        if (this.selectOrder.length == 0) {
            this.allSelect = false
        }
        console.log(this.selectOrder);
        
    }
    cancelAllOrder(){//批量取消订单
        if (this.selectOrder.length == 0) {
            return false
        }
        this.fetch({
            url: this.api.cancelAllOrder,
            data:{
                esc_order_id:this.selectOrder.join(',')
            }
        }).then((res:any) => {
            let message:string ='';
            this.orderData.forEach((order:any) => {
                res.forEach((orderRes:any) => {
                    if (orderRes.escOrderId == order.escOrderid) {
                        if (orderRes.failReason.trim() == '成功') {//操作成功改变订单状态
                            order.orderStatusName = '已取消'
                        }else{
                            if (message) {
                                message += `\n${orderRes.escOrderId} ${orderRes.failReason}`
                            }else{
                                message = `${orderRes.escOrderId} ${orderRes.failReason}`
                            }
                            if (orderRes.failReason.trim() == '已取消的订单不能再取消') {//取消失败原因是已取消的   改变订单状态
                                order.orderStatusName = '已取消'
                            }
                        }
                    }
                });
            });
            if (message) {
                this.$dialog
                .alert({
                    message: message,
                    width:'400'
                }).then(() => {
                });
            }else{
                this.$toast('取消成功')
            }
            this.isSelect = false
            this.allSelect = false
            this.selectOrder = []
        }).catch((err:any)=>{
            if (err.msg) {
                this.$toast(err.msg)
            }
        })		
    }
    cancelOrder(order:any){//取消订单
        this.fetch({
            url: this.api.cancelOrder,
            data:{
                esc_order_id:order.escOrderid
            }
        }).then((res:any) => {
            this.$toast('订单取消成功');
            order.orderStatusName = "已取消"
        }).catch((err:any)=>{
            if (err.msg) {
                this.$toast(err.msg)
            }
        })		
    }
	getOrderListData(){//获取直播订单
        this.isSelect = false
        this.allSelect = false
        this.selectOrder = []
        let orderStatus:any = this.$refs.orderStatus
        this.params.order_status = orderStatus.value
        let url = `${this.api.getOrderListData}?page_num=${this.params.page_num}&page_size=${this.params.page_size}&order_status=${this.params.order_status}&seller_onlyid=${this.params.seller_onlyid}&listingid=${this.params.listingid}`
        if (this.params.times) {
            url+= `&start_time=${this.params.times[0] || ''}&end_time=${this.params.times[1] || ''}`
        }
		this.fetch({
			url: url,
			method: "get",
		}).then((res:any) => {
			if(res){
                res.result.forEach((el:any) => {
                    if (el.orderStatusName == '待付款') {
                        el.select = false
                    }
                });
                this.params.pageTotal = Math.ceil(res.total / this.params.page_size)
                this.orderData = res.result
			}
            console.log(this.orderData.length);
            this.loading = false
		}).catch((err:any)=>{
            if (err.data) {
                this.$toast(err.data)
            }else{
                this.$toast('订单请求失败')
            }
            this.loading = false
		})		
	}
}
